import React from 'react'
import { isAmwellTheme } from '@sukiai/components/lib/util'

const LightTheme = React.lazy(() => import('./AntdLightMode'))
const DarkTheme = React.lazy(() => import('./AntdDarkMode'))

const AntdThemeSelector = ({ children }) => {
  return (
    <>
      <React.Suspense fallback={<></>}>
        {isAmwellTheme() ? <DarkTheme /> : <LightTheme />}
      </React.Suspense>
      {children}
    </>
  )
}

export default AntdThemeSelector
